const enTranslations = {
  navItems: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    portfolio: 'Portfolio',
    contact: 'Contact',
    blog: 'Blog'
  },
  hero: {
    title: 'I am Moudondi Godfried',
    subtitle: 'Creating Smooth Digital Experiences',
    description: 'I am a front-end developer specialized in creating modern and responsive websites and web applications that prioritize user experience and performance.',
    contactButton: 'Contact Me',
    portfolioButton: 'My Portfolio',
    cta: 'Contact Me'
  },
  about: {
    title: 'About Me',
    paragraph1: 'With over 10 years of experience in web development, I have honed my craft to create digital solutions that are not only visually appealing but also highly functional and user-friendly.',
    paragraph2: 'My approach is centered around three fundamental principles: ',
    paragraph2FeatureBold1: 'simplicity',
    paragraph2FeatureBold2: 'performance',
    paragraph2FeatureBold3: 'user-centered design',
    paragraph3: 'I believe that the best websites are those that communicate clearly, load quickly, and provide an intuitive experience for users.',
    paragraph4: 'My technical expertise includes modern JavaScript frameworks, responsive design techniques, and optimization strategies that ensure your website works perfectly on all devices.',
    subtitle: 'What distinguishes my work:',
    qualities: [
      "Meticulous attention to detail",
      "Clean, maintainable code",
      "Emphasis on accessibility",
      "Performance optimization",
      "Responsive design mindset",
      "Focus on business objectives"
    ]
  },
  services: {
    title: 'Services I Offer',
    items: [
      {
        title: 'Responsive Web Design',
        description: 'Creating websites that provide an optimal viewing experience across all devices, from desktop computers to mobile phones.'
      },
      {
        title: 'Front-End Development',
        description: 'Building interactive and dynamic user interfaces using modern frameworks and libraries like React, Vue, or Angular.'
      },
      {
        title: 'UI/UX Consulting',
        description: 'Designing intuitive user experiences and interfaces that align with your brand identity and meet user needs.'
      },
      {
        title: 'Mobile-First Strategy',
        description: 'Developing with a mobile-first approach to ensure performance and usability on smaller screens.'
      },
      {
        title: 'Interactive Prototyping',
        description: 'Creating interactive prototypes to test user flows, functionalities, and gather feedback before final implementation.'
      },
      {
        title: 'Design Systems',
        description: 'Developing comprehensive design systems that ensure consistency and scalability across your digital products.'
      }
    ]
  },
  portfolio: {
    title: 'Portfolio',
    description: 'A selection of projects showcasing my skills and experience.',
    viewMore: 'View More',
    subtitle: "Discover some of my recent projects and examples of work",
    items: [
      {
        title: "Guesthouse [Le Mans]",
        description: "A website for a guesthouse in Le Mans, highlighting rooms, amenities, and online booking.",
        tags: ["HTML/CSS", "ViteJs", "NodeJs"],
        thumbnail: "/assets/portfolio/pause-bonheur-portfolio.webp"
      },
      {
        title: "Therismos Global",
        description: "A church website for Therismos Global, featuring event management, sermon archives, and community engagement.",
        tags: ["React", "Node.js", "Wordpress", "MysQL"],
        thumbnail: "/assets/portfolio/therismos-global-portfolio.webp"
      },
      {
        title: "FreelBills",
        description: "A financial management application for freelancers, enabling income and expense tracking along with invoice generation capabilities.",
        tags: ["React Native", "GraphQL", "AWS"]
      }
    ]
  },
  contact: {
    title: 'Get in Touch',
    subtitle: 'Interested in working together? Feel free to reach out through any of the channels below.',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    send: 'Send Message',
    success: 'Message sent successfully!',
    error: 'Failed to send message. Please try again.',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    locationLabel: 'Location',
    connectOnline: 'Connect Online',
    emailAddress: 'impelatek@gmail.com',
    phoneNumber: '+1 (123) 456-7890',
    location: 'Paris, France'
  },
  blogPage: {
    title: 'Blog',
    description: 'Thoughts, ideas, and insights on web development and design.',
    readMore: 'Read More'
  },
  blogArticle: {
    backToBlog: 'Back to Blog',
    notFound: 'Article Not Found',
    notFoundDesc: 'The article you are looking for does not exist or may have been removed.',
    aboutAuthor: 'About the Author'
  },
  footer: {
    copyright: "© {{year}} Impelatek. All rights reserved.",
    developper: 'Developper'
  },
  cookies: {
    banner: {
      title: "Cookies & Privacy",
      description: "We use cookies to improve your experience. You can customize your preferences.",
      acceptAll: "Accept All",
      acceptNecessary: "Necessary Only",
      customize: "Customize"
    },
    modal: {
      title: "Cookie Settings",
      description: "We respect your privacy. Choose the types of cookies you allow. You can change these settings at any time.",
      savePreferences: "Save Preferences",
      acceptAll: "Accept All",
      acceptNecessary: "Necessary Only",
      notice: "By continuing to use this site, you accept our use of cookies in accordance with our privacy policy."
    },
    categories: {
      necessary: {
        title: "Necessary Cookies",
        description: "These cookies are essential for the website to function and cannot be disabled.",
        required: "Required",
        alwaysActive: "Always Active"
      },
      analytics: {
        title: "Analytics Cookies",
        description: "These cookies help us understand how visitors interact with the website."
      },
      marketing: {
        title: "Marketing Cookies",
        description: "These cookies are used to personalize ads and measure their effectiveness."
      },
      preferences: {
        title: "Preference Cookies",
        description: "These cookies allow us to remember your preferences and personalize your experience."
      }
    },
    settings: {
      title: "Cookie Settings",
      lastModified: "Last modified:",
      expiryNotice: "These settings are saved locally and will expire after 1 year.",
      aboutCookies: "About Cookies",
      aboutDescription: "Cookies are small text files stored on your device when you visit our site. They help us improve your experience and analyze site usage.",
      allowed: "Allowed",
      blocked: "Blocked",
      enable: "Enable",
      disable: "Disable"
    }
  }
};

export default enTranslations;
